export default function Tiktok({ className }: { className ?: string}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      className={className}
    >
      <path
        d="M13.0287 6.40722V13.3076C13.0287 16.7222 10.2607 19.4902 6.84607 19.4902C3.4315 19.4902 0.663452 16.7222 0.663452 13.3076C0.663452 9.89301 3.4315 7.125 6.84607 7.125C7.33716 7.125 7.81484 7.18225 8.27283 7.29044V10.2989C7.84042 10.0934 7.35666 9.97852 6.84607 9.97852C5.00745 9.97852 3.51697 11.469 3.51697 13.3076C3.51697 15.1462 5.00745 16.6367 6.84607 16.6367C8.68468 16.6367 10.1752 15.1462 10.1752 13.3076V0.466797H13.0287C13.0287 3.09338 15.158 5.22266 17.7845 5.22266V8.07617C15.985 8.07617 14.3314 7.45152 13.0287 6.40722Z"
        fill="black"
      />
    </svg>
  );
}
